import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vee-trading-hub/artifacts/k4o9jcwu_VEE%20CONSULTANCY%20LOGO.png";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[#03060D] text-slate-200 font-body">
      <nav className="sticky top-0 z-50 backdrop-blur-xl bg-[#03060D]/80 border-b border-slate-800">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="VEE Consultancy" className="h-10 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-slate-300 hover:text-emerald-400 transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to Home
          </Link>
        </div>
      </nav>

      <section className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-emerald-400 mb-4">
          VEE CONSULTANCY
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-10 leading-tight">
          {title}
        </h1>
        <div className="prose prose-invert max-w-none prose-headings:font-display prose-headings:text-white prose-p:text-slate-300 prose-p:leading-relaxed prose-strong:text-white prose-a:text-emerald-400 prose-li:text-slate-300 space-y-5 text-[15px]">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 text-xs text-slate-500">
          Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
          <span className="mx-3">•</span>
          Questions?{" "}
          <Link to="/contact" className="text-emerald-400 hover:underline">Contact us</Link>
        </div>
      </section>

      <footer className="border-t border-slate-800 py-8 px-4 md:px-8 bg-[#030711]">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500 font-mono uppercase tracking-[0.2em]">
          <div>© {new Date().getFullYear()} VEE Consultancy</div>
          <div className="flex flex-wrap gap-4 md:gap-6">
            <Link to="/terms" className="hover:text-emerald-400 transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-emerald-400 transition-colors">Privacy</Link>
            <Link to="/what-we-provide" className="hover:text-emerald-400 transition-colors">What We Provide</Link>
            <Link to="/contact" className="hover:text-emerald-400 transition-colors">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
